import { render, staticRenderFns } from "./Think.vue?vue&type=template&id=989efb2e&scoped=true&"
import script from "./Think.vue?vue&type=script&lang=js&"
export * from "./Think.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989efb2e",
  null
  
)

export default component.exports